import { Configuration, LogLevel } from '@azure/msal-browser'

import { CopTokenAuthConfig } from './config'

export const buildMsalConfig = (cfg: CopTokenAuthConfig): Configuration => ({
    auth: {
        clientId: cfg.clientId,
        authority: `${cfg.authorityHost.replace(/\/$/, '')}/${cfg.tenantId}`,
        redirectUri: window.location.origin + (cfg.redirectPath || ''),
    },
    cache: {
        cacheLocation: cfg.cacheLocation === 'sessionStorage' ? 'sessionStorage' : 'localStorage',
    },
    system: {
        loggerOptions: {
            // eslint-disable-next-line no-console
            loggerCallback: (_level, message, containsPii) => {
                if (containsPii || !cfg.debug) return
                // eslint-disable-next-line no-console
                console.info('[CopTokenAuth][MSAL]', message)
            },
            logLevel: cfg.debug ? LogLevel.Info : LogLevel.Warning,
        },
    },
})
